import React from 'react'
import { Row, Space, Text, theme } from 'ui'
import useStore from 'store'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Card } from '@material-ui/core'
import Money from './Money'
import { useHistory } from 'react-router'

import { ChevronLeft } from '@material-ui/icons'
import { Table, TableBody, TableCell, TableRow, TableHead } from '@material-ui/core'

const StyledColumn = styled.div`
    display: flex; 
    flex-direction: column;
`
const StyledCollapseButton = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:center;
  cursor:pointer;
`

const StyledChevronLeft = styled(ChevronLeft) <{ collapsed: boolean }>`
  transform: rotate(${p => p.collapsed ? 90 : 270}deg);
  color: ${theme.color.darkerGray};
  font-size: 45px; 
  align-items:center;
  text-align:center;
  display:flex;
`

const StyledContainer = styled(Card) <{ disabled: boolean }>`
  
  flex-direction:row;
  justify-content:space-between;
  cursor:${p => p.disabled ? 'auto' : 'pointer'};
  padding:12px 12px 0px 12px;
  margin:8px;
`
const StyledTitle = styled(Text)`
  line-height:1.3;
  flex:1;
  text-align: center;
`
const TableCellStyled = styled(TableCell)`
  justify-content: center;
  align-items: center;
` 

interface IPaymentItemSummary {
    summary: any,
    metaData: any
}

const PaymentItemSummary: React.FC<IPaymentItemSummary> = 
    ({ summary, metaData }) => {
        const { t } = useTranslation('budget')
        const [collapsed, setCollapsed] = React.useState(false)
        const toggleCollapse = () => {
            setCollapsed(!collapsed)
        }

        const { budgetStore } = useStore()    
        const getChargeeName = (chargeeId: any) => {
            const chargee = metaData.chargees.filter((item: any) => (item.id == chargeeId))
            if (chargee.length > 0) {
                return chargee[0].displayName;
            }

            return '';
        }
    
    return (
        <StyledContainer disabled={false} >
            <StyledColumn>
                <StyledTitle weight='bold' size='xl'>{t`charges_credits_detail`}</StyledTitle>
                    <Row align='stretch'>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t`col_ledger_name`}</TableCell>
                                    <TableCell>{t`col_opening_balance`}</TableCell>
                                    <TableCell>{t`col_total_charges`}</TableCell>
                                    <TableCell>{t`col_total_credits`}</TableCell>
                                    <TableCell>{t`col_account_balance`}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(!collapsed && summary.length > 1 ? [summary[0]] : summary).map((item: any) => {
                                    const totalDebit = item.openingBalance >= 0 ? item.totalDebit - item.openingBalance : item.totalDebit 
                                    const totalCredit = item.openingBalance < 0 ? item.totalCredit + item.openingBalance : item.totalCredit 
                                    
                                    return (
                                        <TableRow>
                                            <TableCellStyled>{getChargeeName(item.chargeeId)}</TableCellStyled>
                                            <TableCellStyled>
                                                <Money amount={budgetStore.agorotToShekel(item.openingBalance * -1)}
                                                    moneySize={32}
                                                    currencySize={20}
                                                    align='center'
                                                />
                                            </TableCellStyled>
                                            <TableCellStyled>
                                                <Money amount={budgetStore.agorotToShekel(totalDebit)}
                                                    moneySize={32}
                                                    currencySize={20}
                                                    align='center'
                                                    moneyColor={theme.color.budgetRed}
                                                    agorotColor={theme.color.budgetRed}
                                                />
                                            </TableCellStyled>
                                            <TableCellStyled>
                                                <Money amount={budgetStore.agorotToShekel(totalCredit)}
                                                    moneySize={32}
                                                    currencySize={20}
                                                    align='center'
                                                    moneyColor={theme.color.budgetDarkGreen}
                                                    agorotColor={theme.color.budgetDarkGreen}
                                                />
                                            </TableCellStyled>
                                            <TableCellStyled>
                                                <Money amount={budgetStore.agorotToShekel(item.chargingSum  * -1)}
                                                    moneySize={32}
                                                    currencySize={20}
                                                    align='center'
                                                />
                                            </TableCellStyled>
                                        </TableRow>        
                                    )
                                })}                    
                            </TableBody>
                        </Table>
                </Row>   
                {Boolean(summary?.length > 1) && (
                    <>
                    <Row justify='center'>
                        <StyledCollapseButton onClick={toggleCollapse}>
                            <StyledChevronLeft collapsed={collapsed} />
                         </StyledCollapseButton>
                    </Row>
                    </>
                )} 
            </StyledColumn>     
        </StyledContainer>
    )
}

export default observer(PaymentItemSummary)